/**
 * Use Google Analytics 4 tracking via GTM
 *
 * @returns {Object} - { track: Function }
 */
const useGA4Tracking = () => {
  const dataLayer = (window.dataLayer = window.dataLayer || []);

  const track = (data, debug) => {
    // Roll up other event parameters fields
    const {
      event,
      name,
      type,
      region,
      variant,
      offer,
      position,
      destination_url,
      destination_type,
      step_number,
      input_count,
      fields,
      error,
      language,
      ...otherData
    } = data;
    const other = Object.keys(otherData)
      .map((key) => `${key}: ${otherData[key]}`)
      .join(' | ');

    let gaData = {
      event: event || 'ga4_event',
      name,
      type,
      region,
      variant,
      offer,
      position,
      destination_url,
      destination_type,
      step_number,
      input_count,
      fields,
      error,
      language,
      other,
      host: window.location.host,
    };

    // Remove empty fields
    gaData = Object.fromEntries(
      Object.entries(gaData).filter(([key, value]) => Boolean(value))
    );

    if (!debug) {
      dataLayer.push(gaData);
    } else {
      console.log('track:ga4', gaData);
    }
  };

  return { track };
};

export default useGA4Tracking;
